import { IScheduleStatusDTO } from 'src/api/dtos';
import http from 'src/api/http';
import ESSRepository from 'src/api/repositories/ess/ess.repository';
import { IListQueryResult } from 'src/api/types';
import { getAxiosParams } from 'src/shared/utils';

export default class ScheduleRepository extends ESSRepository {
  private static readonly baseRoute = '/schedules';
  private static readonly apiURL = ScheduleRepository.setBaseUrl(this.baseURL, this.baseRoute);

  public getStatuses = async (params: { date?: string }): Promise<IScheduleStatusDTO[]> => {
    try {
      const { data } = await http.get<IListQueryResult<IScheduleStatusDTO>>(
        `${ScheduleRepository.apiURL}/statuses`,
        getAxiosParams(params),
      );
      return data.items;
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
